import { useQueryClient } from "@tanstack/react-query";
import { QueueLayout } from "../../features/web3/forex/components/QueueLayout";
import { TIER } from "./api";
import { ListView } from "./parts";
import { CONNECTION_COLUMNS, END_CAUSE, connectionRow } from "./rows";

export default function Connections() {
  const qc = useQueryClient();
  return (
    <QueueLayout
      eyebrow="Forex Admin"
      title="Copy trading"
      accent="connections"
      description="Who copies whom. A disconnect reads as Disconnecting until it ends, however long that takes. Disconnecting also covers a master disconnecting all its copiers, and an ended connection shows why it ended."
      onRefresh={() => qc.invalidateQueries({ queryKey: ["forex-admin"] })}
    >
      <ListView
        path="/connections/admin"
        empty={{ status: "", endCause: "", username: "", login: "", tier: "", master: "" }}
        fields={[
          { name: "status", label: "Status", options: [
            { value: "", label: "All" }, { value: "STANDING", label: "Standing" },
            { value: "DISCONNECTING", label: "Disconnecting" }, { value: "ENDED", label: "Ended" },
          ] },
          // v1.22.0: exact end cause; a connection not ended is left out.
          { name: "endCause", label: "End cause", options: [
            { value: "", label: "All" },
            ...Object.entries(END_CAUSE).map(([value, label]) => ({ value, label })),
          ] },
          { name: "username", label: "Copier username" },
          { name: "login", label: "Copier login" },
          { name: "tier", label: "Copier tier", options: TIER },
          { name: "master", label: "Master id" },
        ]}
        columns={CONNECTION_COLUMNS}
        row={connectionRow}
        label="connections"
      />
    </QueueLayout>
  );
}
